import { Component, inject, Input, signal } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { timer } from 'rxjs';

@Component({
  standalone: false,
  selector: 'liberro-payment-row',
  templateUrl: './payment-row.component.html',
  styleUrl: './payment-row.component.less'
})
export class PaymentRowComponent {
  @Input({ required: true }) public translateKey!: string;
  @Input({ required: true }) public value!: string;
  @Input() public hideClipboardCopy = false;

  public tooltipVisible = signal<boolean>(false);
  private clipboard = inject(Clipboard);

  public copyToClipboard(): void {
    this.clipboard.copy(this.value);
    this.tooltipVisible.set(true);
    timer(1000).subscribe(() => this.tooltipVisible.set(false));
  }
}

